/* Current Nostalgia - liquid light (v1.12-v1.15): a small WebGL fluid simulation in the homepage
   hero's headline panel, stirred by the cursor or a finger. <canvas data-cn-liquid>: violet liquid
   computed live. With data-video and a <video data-src> beside it, the liquid moves that footage
   instead; data-rate slows the video, data-clear makes its dark parts see-through, data-crt adds an
   old-TV look. Reduced motion: nothing starts. Needs cn-liquid-shaders.js first. No backslashes. */
(function () {
 if (window.__cnLiquid) return;
 window.__cnLiquid = true;
 if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
 var NL = String.fromCharCode(10);

 function hsv(h, s, v) {
  var i = Math.floor(h * 6), f = h * 6 - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s);
  var m = [[v, t, p], [q, v, p], [p, v, t], [p, q, v], [t, p, v], [v, p, q]][i % 6];
  return { r: m[0], g: m[1], b: m[2] };
 }

 function start(canvas, vid) {
  var G = window.__cnLiquidGL;
  if (!G) return;
  var params = { alpha: !!vid, depth: false, stencil: false, antialias: false, preserveDrawingBuffer: false, powerPreference: 'low-power' };
  var gl = canvas.getContext('webgl2', params), gl2 = !!gl;
  if (!gl) gl = canvas.getContext('webgl', params);
  if (!gl) return;
  var type, linear;
  if (gl2) {
   gl.getExtension('EXT_color_buffer_float');
   gl.getExtension('EXT_color_buffer_half_float');
   type = gl.HALF_FLOAT; linear = true;
  } else {
   var hf = gl.getExtension('OES_texture_half_float');
   if (!hf) return;
   gl.getExtension('EXT_color_buffer_half_float');
   linear = !!gl.getExtension('OES_texture_half_float_linear');
   type = hf.HALF_FLOAT_OES;
  }
  var internal = gl2 ? gl.RGBA16F : gl.RGBA;

  var hues = (canvas.getAttribute('data-hue') || '0.69,0.88').split(',').map(parseFloat);
  var host = canvas.parentNode;
  var cfg = { sim: 128, dye: window.innerWidth < 750 ? 384 : 640, dyeFade: 0.45, velFade: 0.3, pressure: 0.8, iters: 18, curl: 12, radius: 0.0045, force: 5200 };
  /* footage: a coarse field of how far the picture has flowed; slow, gentle, easing back */
  var slow = 1, rate = 1, crt = 0, clear = 0;
  if (vid) {
   cfg.dye = 256; cfg.dyeFade = 0.9; cfg.velFade = 1.2; cfg.force = 1500; slow = 0.4;
   rate = vid.playbackRate || 1;
   crt = canvas.hasAttribute('data-crt') ? 1 : 0;
   clear = canvas.hasAttribute('data-clear') ? 1 : 0;
  }

  function shader(kind, src) {
   var s = gl.createShader(kind);
   gl.shaderSource(s, src);
   gl.compileShader(s);
   return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null;
  }
  var vs = shader(gl.VERTEX_SHADER, G.VS);
  if (!vs) return;
  function program(name) {
   var src = G.HEAD + G.FS[name];
   if (name === 'advect' && !linear) src = '#define MANUAL_FILTERING' + NL + src;
   var fs = shader(gl.FRAGMENT_SHADER, src);
   if (!fs) return null;
   var p = gl.createProgram();
   gl.attachShader(p, vs); gl.attachShader(p, fs);
   gl.bindAttribLocation(p, 0, 'aPosition');
   gl.linkProgram(p);
   if (!gl.getProgramParameter(p, gl.LINK_STATUS)) return null;
   var u = {}, n = gl.getProgramParameter(p, gl.ACTIVE_UNIFORMS);
   for (var i = 0; i < n; i++) { var nm = gl.getActiveUniform(p, i).name; u[nm] = gl.getUniformLocation(p, nm); }
   return { p: p, u: u };
  }
  var P = {};
  for (var k in G.FS) {
   if (vid ? k === 'display' : (k === 'video' || k === 'push')) continue;
   P[k] = program(k); if (!P[k]) return;
  }

  gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), gl.STATIC_DRAW);
  gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, gl.createBuffer());
  gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array([0, 1, 2, 0, 2, 3]), gl.STATIC_DRAW);
  gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
  gl.enableVertexAttribArray(0);

  function blit(t) {
   if (t) { gl.viewport(0, 0, t.w, t.h); gl.bindFramebuffer(gl.FRAMEBUFFER, t.fbo); }
   else { gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight); gl.bindFramebuffer(gl.FRAMEBUFFER, null); }
   gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
  }
  function texParams(f) {
   var T = gl.TEXTURE_2D;
   [[gl.TEXTURE_MIN_FILTER, f], [gl.TEXTURE_MAG_FILTER, f], [gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE], [gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE]].forEach(function (q) { gl.texParameteri(T, q[0], q[1]); });
  }
  function fbo(w, h) {
   gl.activeTexture(gl.TEXTURE0);
   var tex = gl.createTexture();
   gl.bindTexture(gl.TEXTURE_2D, tex);
   texParams(linear ? gl.LINEAR : gl.NEAREST);
   gl.texImage2D(gl.TEXTURE_2D, 0, internal, w, h, 0, gl.RGBA, type, null);
   var fb = gl.createFramebuffer();
   gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
   gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, tex, 0);
   gl.viewport(0, 0, w, h);
   gl.clear(gl.COLOR_BUFFER_BIT);
   return { tex: tex, fbo: fb, w: w, h: h, tx: 1 / w, ty: 1 / h,
    bind: function (unit) { gl.activeTexture(gl.TEXTURE0 + unit); gl.bindTexture(gl.TEXTURE_2D, tex); return unit; } };
  }
  function pair(w, h) {
   var a = fbo(w, h), b = fbo(w, h);
   return { w: w, h: h, tx: a.tx, ty: a.ty, read: a, write: b, swap: function () { var t = this.read; this.read = this.write; this.write = t; } };
  }
  function res(r) {
   var a = gl.drawingBufferWidth / gl.drawingBufferHeight;
   if (a < 1) a = 1 / a;
   var lo = Math.round(r), hi = Math.round(r * a);
   return gl.drawingBufferWidth > gl.drawingBufferHeight ? { w: hi, h: lo } : { w: lo, h: hi };
  }

  var dye, vel, div, curlF, prs;
  function size() {
   var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
   var w = Math.max(1, Math.round(canvas.clientWidth * dpr)), h = Math.max(1, Math.round(canvas.clientHeight * dpr));
   if (canvas.width === w && canvas.height === h && dye) return;
   canvas.width = w; canvas.height = h;
   var s = res(cfg.sim), d = res(cfg.dye);
   dye = pair(d.w, d.h); vel = pair(s.w, s.h);
   div = fbo(s.w, s.h); curlF = fbo(s.w, s.h); prs = pair(s.w, s.h);
  }
  size();
  gl.bindFramebuffer(gl.FRAMEBUFFER, dye.read.fbo);
  if (gl.checkFramebufferStatus(gl.FRAMEBUFFER) !== gl.FRAMEBUFFER_COMPLETE) return;

  /* the video's newest frame and the one before, so each can fade into the next */
  var vtex = null, ptex = null, dead = false, lastT = -1, tFrame = 0;
  function vt() { var t = gl.createTexture(); gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, t); texParams(gl.LINEAR); return t; }
  if (vid) { vtex = vt(); ptex = vt(); }
  /* a video from a server that does not allow it cannot be drawn: leave the plain video showing */
  function upload(t) {
   gl.activeTexture(gl.TEXTURE1);
   gl.bindTexture(gl.TEXTURE_2D, t);
   gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
   try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, vid); return true; }
   catch (e) { dead = true; canvas.classList.remove('is-on'); host.classList.remove('is-liquid'); return false; }
  }

  function use(name) { gl.useProgram(P[name].p); return P[name].u; }
  function ts(u) { gl.uniform2f(u.texelSize, vel.tx, vel.ty); }
  function color(k) {
   var h = hues[0] + Math.random() * (hues[1] - hues[0]);
   var c = hsv(h, 0.78 + Math.random() * 0.2, 1);
   return { r: c.r * k, g: c.g * k, b: c.b * k };
  }
  function splat(x, y, dx, dy, c, big) {
   var a = canvas.width / canvas.height, r = cfg.radius * (big || 1);
   if (a > 1) r *= a;
   var u = use('splat');
   gl.uniform1i(u.uTarget, vel.read.bind(0));
   gl.uniform1f(u.aspectRatio, a);
   gl.uniform2f(u.point, x, y);
   gl.uniform3f(u.color, dx, dy, 0);
   gl.uniform1f(u.radius, r);
   blit(vel.write); vel.swap();
   if (!c) return;
   gl.uniform1i(u.uTarget, dye.read.bind(0));
   gl.uniform3f(u.color, c.r, c.g, c.b);
   blit(dye.write); dye.swap();
  }
  function randomSplat(k) {
   var ang = Math.random() * Math.PI * 2, f = 300 + Math.random() * 500;
   splat(0.1 + Math.random() * 0.8, 0.1 + Math.random() * 0.8, Math.cos(ang) * f, Math.sin(ang) * f, color(k), 2.6);
  }

  function step(dt) {
   var u;
   u = use('curl'); ts(u); gl.uniform1i(u.uVelocity, vel.read.bind(0)); blit(curlF);
   u = use('vorticity'); ts(u); gl.uniform1i(u.uVelocity, vel.read.bind(0));
   gl.uniform1i(u.uCurl, curlF.bind(1)); gl.uniform1f(u.curl, cfg.curl); gl.uniform1f(u.dt, dt); blit(vel.write); vel.swap();
   u = use('divergence'); ts(u); gl.uniform1i(u.uVelocity, vel.read.bind(0)); blit(div);
   u = use('clear'); gl.uniform1i(u.uTexture, prs.read.bind(0)); gl.uniform1f(u.value, cfg.pressure); blit(prs.write); prs.swap();
   u = use('pressure'); ts(u); gl.uniform1i(u.uDivergence, div.bind(0));
   for (var i = 0; i < cfg.iters; i++) { gl.uniform1i(u.uPressure, prs.read.bind(1)); blit(prs.write); prs.swap(); }
   u = use('gradient'); ts(u); gl.uniform1i(u.uPressure, prs.read.bind(0));
   gl.uniform1i(u.uVelocity, vel.read.bind(1)); blit(vel.write); vel.swap();
   u = use('advect'); ts(u);
   if (!linear) gl.uniform2f(u.dyeTexelSize, vel.tx, vel.ty);
   var v = vel.read.bind(0);
   gl.uniform1i(u.uVelocity, v); gl.uniform1i(u.uSource, v); gl.uniform1f(u.dt, dt); gl.uniform1f(u.dissipation, cfg.velFade);
   blit(vel.write); vel.swap();
   if (!linear) gl.uniform2f(u.dyeTexelSize, dye.tx, dye.ty);
   gl.uniform1i(u.uVelocity, vel.read.bind(0)); gl.uniform1i(u.uSource, dye.read.bind(1)); gl.uniform1f(u.dissipation, cfg.dyeFade);
   blit(dye.write); dye.swap();
   if (!vid) return;
   u = use('push');
   gl.uniform1i(u.uTarget, dye.read.bind(0)); gl.uniform1i(u.uVelocity, vel.read.bind(1));
   gl.uniform2f(u.k, dt * vel.tx, dt * vel.ty);
   blit(dye.write); dye.swap();
  }
  function draw(now) {
   var u;
   if (vid) {
    /* a new frame: the last one becomes the one it fades from (assumes 30 frames a second) */
    if (vid.currentTime !== lastT) {
     var t = ptex; ptex = vtex; vtex = t;
     if (!upload(vtex) || (lastT < 0 && !upload(ptex))) return false;
     lastT = vid.currentTime; tFrame = now;
    }
    u = use('video');
    gl.uniform1i(u.uTexture, dye.read.bind(0));
    gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, vtex);
    gl.activeTexture(gl.TEXTURE2); gl.bindTexture(gl.TEXTURE_2D, ptex);
    gl.uniform1i(u.uVideo, 1); gl.uniform1i(u.uPrev, 2);
    gl.uniform1f(u.mixF, Math.min(1, (now - tFrame) * 0.03 * rate));
    gl.uniform1f(u.time, (now / 1000) % 1000);
    gl.uniform1f(u.crt, crt); gl.uniform1f(u.clear, clear);
    /* crop the picture to fill the box, like object-fit: cover */
    var ca = canvas.width / canvas.height, va = (vid.videoWidth || 1) / (vid.videoHeight || 1);
    gl.uniform2f(u.cover, ca < va ? ca / va : 1, ca < va ? 1 : va / ca);
   } else {
    u = use('display');
    gl.uniform2f(u.texelSize, dye.tx, dye.ty);
    gl.uniform1i(u.uTexture, dye.read.bind(0));
    gl.uniform3f(u.base, 0.075, 0.03, 0.115);
   }
   blit(null);
   return true;
  }

  /* each pointer move pushes the liquid the way the pointer went */
  var queue = [], last = null, busy = 0;
  function move(cx, cy) {
   var r = canvas.getBoundingClientRect();
   var x = (cx - r.left) / r.width, y = 1 - (cy - r.top) / r.height;
   if (x < -0.05 || x > 1.05 || y < -0.05 || y > 1.05) { last = null; return; }
   if (last) {
    var mx = x - last.x, my = y - last.y, dx = mx, dy = my, a = r.width / r.height;
    if (a < 1) dx *= a; else dy /= a;
    if (dx || dy) queue.push([x, y, dx * cfg.force, dy * cfg.force, mx, my]);
   }
   last = { x: x, y: y };
   busy = performance.now() + (vid ? 15000 : 6000);
   wake();
  }
  host.addEventListener('pointermove', function (e) { if (e.pointerType !== 'touch') move(e.clientX, e.clientY); }, { passive: true });
  host.addEventListener('pointerleave', function () { last = null; }, { passive: true });
  host.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) move(t.clientX, t.clientY); }, { passive: true });
  host.addEventListener('touchend', function () { last = null; }, { passive: true });

  var visible = true, raf = 0, then = 0, nextDrift = 0, shown = false, drawn = 0;
  function frame(now) {
   raf = 0;
   if (!visible || document.hidden || dead) return;
   /* footage: wait for a first frame; left alone, redraw ~30 times a second for fades and static */
   if (vid && vid.readyState < 2) return;
   if (vid && shown && now >= busy && now - drawn < 30) { raf = requestAnimationFrame(frame); return; }
   var dt = Math.min((now - (then || now)) / 1000, 0.034);
   then = now;
   size();
   while (queue.length > 6) queue.shift();
   while (queue.length) {
    var q = queue.shift();
    splat(q[0], q[1], q[2], q[3], vid ? null : color(0.24), vid ? 2.6 : 1);
   }
   if (!vid && now > nextDrift) { randomSplat(0.17); nextDrift = now + 1300 + Math.random() * 1300; }
   /* footage: the liquid only needs working out for a while after someone stirs it */
   if (!vid || now < busy) step(dt * slow);
   if (!draw(now)) return;
   drawn = now;
   if (!shown) { shown = true; canvas.classList.add('is-on'); if (vid) host.classList.add('is-liquid'); }
   raf = requestAnimationFrame(frame);
  }
  function wake() { if (!raf && visible && !document.hidden && !dead) { then = 0; raf = requestAnimationFrame(frame); } }
  function playing() {
   if (!vid) return;
   if (visible && !document.hidden) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
   else vid.pause();
  }

  if (!vid) for (var i = 0; i < 7; i++) randomSplat(0.3);
  else ['loadeddata', 'playing', 'seeked'].forEach(function (t) { vid.addEventListener(t, wake); });
  if ('IntersectionObserver' in window) {
   new IntersectionObserver(function (es) { visible = es[es.length - 1].isIntersecting; playing(); if (visible) wake(); }).observe(canvas);
  }
  document.addEventListener('visibilitychange', function () { playing(); wake(); });
  canvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); visible = false; canvas.classList.remove('is-on'); host.classList.remove('is-liquid'); });
  wake();
 }

 /* footage first, so it plays even where the liquid cannot run */
 function boot() {
  document.querySelectorAll('canvas[data-cn-liquid]').forEach(function (c) {
   if (c.__cnl) return;
   c.__cnl = true;
   var v = c.hasAttribute('data-video') ? c.parentNode.querySelector('video[data-src]') : null;
   if (v) {
    var r = parseFloat(v.getAttribute('data-rate')) || 1;
    var slowly = function () { v.defaultPlaybackRate = r; v.playbackRate = r; };
    v.muted = true;
    v.src = v.getAttribute('data-src');
    slowly();
    ['loadedmetadata', 'play'].forEach(function (t) { v.addEventListener(t, slowly); });
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
   }
   start(c, v);
  });
 }
 /* start after load, about a second after the page is parsed, or at the first movement */
 var EVENTS = ['pointermove', 'touchstart', 'scroll'], go = false;
 function once() { if (go) return; go = true; EVENTS.forEach(function (t) { window.removeEventListener(t, once); }); boot(); }
 EVENTS.forEach(function (t) { window.addEventListener(t, once, { passive: true }); });
 if (document.readyState === 'complete') setTimeout(once, 200);
 else { window.addEventListener('load', function () { setTimeout(once, 200); }, { once: true });
  document.addEventListener('DOMContentLoaded', function () { setTimeout(once, 1200); }, { once: true }); }
})()